module.exports = __webpack_public_path__ + "img/20200225170623864.f54ebe2b.jpg";